var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComapnyAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comapny_address"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.29083 21.1353L8.29076 21.1352C6.78081 19.1462 5.9651 16.7167 5.96876 14.2195V14.2188C5.96876 11.1605 7.18366 8.22745 9.34619 6.06492C11.5087 3.9024 14.4417 2.6875 17.5 2.6875C20.5583 2.6875 23.4913 3.9024 25.6538 6.06492C27.8164 8.22745 29.0313 11.1605 29.0313 14.2188V14.2195C29.0349 16.7155 28.2196 19.1438 26.7104 21.1319L26.6604 21.1977L26.6595 21.2005L26.658 21.2024L26.5405 21.3559C26.4967 21.4131 26.4517 21.4716 26.4149 21.519C26.3965 21.5428 26.3805 21.5631 26.3681 21.5789C26.3562 21.594 26.3505 21.601 26.3493 21.6025L26.349 21.6028L26.3488 21.6031L17.5 32.0394L8.66066 21.6147C8.53611 21.4559 8.41283 21.2961 8.29083 21.1353Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.4688 10.938V19.1875H22V10V9.77163C22.3001 10.0853 22.4683 10.5029 22.4688 10.938ZM20.781 9.25C21.0951 9.25036 21.4002 9.33819 21.6636 9.5H21.5H13.5H13.3364C13.5998 9.33819 13.9049 9.25036 14.219 9.25H20.781ZM12.5312 10.9378C12.5317 10.5028 12.6999 10.0852 13 9.77163V10V19.1875H12.5312V10.9378Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.9062 18H18.0938V19.1875H16.9062V18ZM16.9062 13.625H18.0938V14.8125H16.9062V13.625Z",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComapnyAddress);
export default __webpack_public_path__ + "static/media/comapny_address.20d8d70f3cb725adbec3b3bb24db7cf1.svg";
export { ForwardRef as ReactComponent };